// This file is auto-generated by @hey-api/openapi-ts

import type {
  AuthRefreshResponse,
  AuthTokenResponse,
  CustomersFindCustomersResponse,
  CustomersGetCustomerResponse,
  OrdersGetCustomerOrdersResponse,
  OrdersGetOrderDetailResponse,
  QuotationsConfigurationTreeResponse,
  QuotationsFindResponse,
  QuotationsGetDoorListResponse,
  QuotationsGetResponse,
  QuotationsToDoorListResponse,
  QuotationsValidateDoorListItemResponse
} from './types.gen'

const tokenSchemaResponseTransformer = (data: any) => {
  data.expires = new Date(data.expires)
  return data
}

export const authTokenResponseTransformer = async (data: any): Promise<AuthTokenResponse> => {
  data = tokenSchemaResponseTransformer(data)
  return data
}

export const authRefreshResponseTransformer = async (data: any): Promise<AuthRefreshResponse> => {
  data = tokenSchemaResponseTransformer(data)
  return data
}

const quotationDetailSchemaResponseTransformer = (data: any) => {
  if (data.dateDelivery) {
    data.dateDelivery = new Date(data.dateDelivery)
  }
  return data
}

const pageQuotationDetailSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => quotationDetailSchemaResponseTransformer(item))
  return data
}

export const quotationsFindResponseTransformer = async (
  data: any
): Promise<QuotationsFindResponse> => {
  data = pageQuotationDetailSchemaResponseTransformer(data)
  return data
}

export const quotationsGetResponseTransformer = async (
  data: any
): Promise<QuotationsGetResponse> => {
  data = quotationDetailSchemaResponseTransformer(data)
  return data
}

const configurationNodeSchemaResponseTransformer = (data: any) => {
  data.children = data.children.map((item: any) => configurationNodeSchemaResponseTransformer(item))
  return data
}

const configurationTreeSchemaResponseTransformer = (data: any) => {
  data.children = data.children.map((item: any) => configurationNodeSchemaResponseTransformer(item))
  return data
}

export const quotationsConfigurationTreeResponseTransformer = async (
  data: any
): Promise<QuotationsConfigurationTreeResponse> => {
  data = configurationTreeSchemaResponseTransformer(data)
  return data
}

const doorListFeatureSchemaResponseTransformer = (data: any) => {
  data.children = data.children.map((item: any) => doorListFeatureSchemaResponseTransformer(item))
  return data
}

const doorListTreeSchemaResponseTransformer = (data: any) => {
  data.features = data.features.map((item: any) => doorListFeatureSchemaResponseTransformer(item))
  return data
}

export const quotationsToDoorListResponseTransformer = async (
  data: any
): Promise<QuotationsToDoorListResponse> => {
  data = doorListTreeSchemaResponseTransformer(data)
  return data
}

export const quotationsGetDoorListResponseTransformer = async (
  data: any
): Promise<QuotationsGetDoorListResponse> => {
  data = doorListTreeSchemaResponseTransformer(data)
  return data
}

const itemValidationSchemaResponseTransformer = (data: any) => {
  data.features = data.features.map((item: any) => doorListFeatureSchemaResponseTransformer(item))
  return data
}

export const quotationsValidateDoorListItemResponseTransformer = async (
  data: any
): Promise<QuotationsValidateDoorListItemResponse> => {
  data = itemValidationSchemaResponseTransformer(data)
  return data
}

const opendoorsApiCustomersSchemasCustomerSchemaResponseTransformer = (data: any) => {
  if (data.lastModified) {
    data.lastModified = new Date(data.lastModified)
  }
  return data
}

const pageCustomerSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) =>
    opendoorsApiCustomersSchemasCustomerSchemaResponseTransformer(item)
  )
  return data
}

export const customersFindCustomersResponseTransformer = async (
  data: any
): Promise<CustomersFindCustomersResponse> => {
  data = pageCustomerSchemaResponseTransformer(data)
  return data
}

const customerDetailSchemaResponseTransformer = (data: any) => {
  if (data.lastModified) {
    data.lastModified = new Date(data.lastModified)
  }
  return data
}

export const customersGetCustomerResponseTransformer = async (
  data: any
): Promise<CustomersGetCustomerResponse> => {
  data = customerDetailSchemaResponseTransformer(data)
  return data
}

const customerOrderViewSchemaResponseTransformer = (data: any) => {
  if (data.productionStartDate) {
    data.productionStartDate = new Date(data.productionStartDate)
  }
  if (data.productionEndDate) {
    data.productionEndDate = new Date(data.productionEndDate)
  }
  return data
}

const pageCustomerOrderViewSchemaResponseTransformer = (data: any) => {
  data.items = data.items.map((item: any) => customerOrderViewSchemaResponseTransformer(item))
  return data
}

export const ordersGetCustomerOrdersResponseTransformer = async (
  data: any
): Promise<OrdersGetCustomerOrdersResponse> => {
  data = pageCustomerOrderViewSchemaResponseTransformer(data)
  return data
}

const subOrderViewSchemaResponseTransformer = (data: any) => {
  if (data.deliverAt) {
    data.deliverAt = new Date(data.deliverAt)
  }
  data.createdAt = new Date(data.createdAt)
  return data
}

const orderDetailViewSchemaResponseTransformer = (data: any) => {
  data.subOrders = data.subOrders.map((item: any) => subOrderViewSchemaResponseTransformer(item))
  return data
}

export const ordersGetOrderDetailResponseTransformer = async (
  data: any
): Promise<OrdersGetOrderDetailResponse> => {
  data = orderDetailViewSchemaResponseTransformer(data)
  return data
}
